<template>
	<div class="view-index-h">
	</div>
</template>

<script>
	export default {
		name: 'IndexH',
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>
<style scoped lang="less">
	.view-index-h {
		width: 100%;
		padding-left: calc(75px * var(--scale-rate));
		position: relative;
	}
</style>